import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

type ChangeIbanSwiftData = {
    id: string;
    iban: string | null;
    swift: string | null
}

type PostAttachmentData = {
    id: string;
    fileName: string;
    file: string;
    metadata: Array<{
        fieldCRM: string;
        type: "Date" | "String";
        value: string;
    }>;
}

export const contractsService = {
    dashboardContracts: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.dashboardContracts);
    },
    getContracts: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getContracts);
    },
    getAttachment: async (contractId: string): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getContractAttachment, {
            documentId: contractId
        });
    },
    acceptAddendum: async (addendumId: string): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.acceptContractAttachment, {
            id: addendumId
        });
    },
    changeIbanSwift: async (data: ChangeIbanSwiftData): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.changeContractIbanSwift, {
            iban: data.iban,
            swift: data.swift,
            id: data.id
        });
    },
    postAttachment: async (data: PostAttachmentData): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postContractAttachment, data);
    }
}